// ReworkModal.jsx – displays a clicked rework sample in a fullscreen overlay
import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './ReworkModal.css';

export default function ReworkModal({ isOpen, onClose, imageSrc, index }) {
  // Prevent background scroll while modal is open & handle Escape key
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal-backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeOut' }}
          onClick={onClose}
        >
          <motion.div
            className="modal-content"
            initial={{ scale: 0.94, opacity: 0, y: 16 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.94, opacity: 0, y: 16 }}
            transition={{ duration: 0.22, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header-bar">
              <span className="modal-tag">✨ Rework #{index + 1}</span>
              <button className="modal-close" onClick={onClose} aria-label="Close modal">×</button>
            </div>
            <div className="modal-image-wrapper">
              <img src={imageSrc} alt={`Rework #${index + 1}`} className="modal-image" />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
